import { render, staticRenderFns } from "./BaseOptions.vue?vue&type=template&id=25b88b75&scoped=true&"
import script from "./BaseOptions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseOptions.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseOptions.vue?vue&type=style&index=0&id=25b88b75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b88b75",
  null
  
)

export default component.exports